'use client'

import { getInitialDescription } from '@utils/utils'
import Image from 'next/image'
import { useState } from 'react'
import styles from './introSection.module.scss'

interface BioSectionProps {
  data: string | undefined
}

const readMoreLogo = 'https://acko-cms.ackoassets.com/read_more_arrow_a0010e4557.svg'

const BioSection: React.FC<BioSectionProps> = ({ data }) => {
  const [showFullBio, setshowFullBio] = useState(false)

  const toggleBio = () => {
    setshowFullBio(!showFullBio)
  }

  return (
    <div className={styles.bioContainer}>
      <p className={`${styles.authorBio} ${showFullBio ? styles.showFull : ''}`}>{data}</p>
      <span className={styles.shortenedAuthorBio}>
        <div className={styles.showDesktop}>
          {!showFullBio ? `${getInitialDescription(data, 80)}...` : null}
          <button type="button" onClick={toggleBio} className={styles.readMoreShowLessButton}>
            {!showFullBio ? 'Read full bio' : 'Show less'}
            <div className={`${styles.readMoreLogo} ${showFullBio ? styles.mirroredLogo : ''}`}>
              <Image src={readMoreLogo} width={24} height={24} alt="Read mode logo" loading="lazy" />
            </div>
          </button>
        </div>
        <div className={styles.showMweb}>
          {!showFullBio ? `${getInitialDescription(data, 30)}...` : null}
          <button type="button" onClick={toggleBio} className={styles.readMoreShowLessButton}>
            {!showFullBio ? 'Read full bio' : 'Show less'}
            <div className={`${styles.readMoreLogo} ${showFullBio ? styles.mirroredLogo : ''}`}>
              <Image src={readMoreLogo} width={24} height={24} alt="Read mode logo" loading="lazy" />
            </div>
          </button>
        </div>
      </span>
    </div>
  )
}

export default BioSection
